import { useEffect, useReducer } from 'react';
import { meetingRecorderDeps, onMeetingRecorderDeps } from './meeting-recorder-deps';

/** Native capability discovery finishes asynchronously after the preload handshake. */
export function useMeetingCaptureSupport() {
  const [, changed] = useReducer((value: number) => value + 1, 0);
  useEffect(() => onMeetingRecorderDeps(changed), []);
  return meetingRecorderDeps()?.captureSupport();
}
